/*----------------------
   VARIATIONS
---------------------- */
// requires formatMoney function in js-common.js
Variations = {
    init: function () {
        function refreshPrice() {
            let variant = currentSelectedComboProperties();
            if (!variant) {
                // update price
                let el = $("[name='price'");
                $(el).html("-");
                console.info("Current selected variant not found on combo, cannot update price");
                return;
            }

            // update price
            let el = $("[name='price'");
            $(el).attr("data-price", variant[4]);
            $(el).attr("data-price-sale", variant[5]);
            $(el).html(formatMoney(variant[4]));

            if (variant[4] != variant[5] && variant[5] > 0) $(".price__sale .price-item").html(formatMoney(variant[5]));
            else $(".price__sale .price-item").html("");

            // update id
            $(".button-add-cart").attr("data-id", variant[1]);
            $(".product-form input.product-variant-id").val(variant[1]);

            // if unavailable, set class
            if (!variant[2]) {
                $(".button-add-cart").addClass("product-unavailable");
                $(".button-add-cart").removeClass("product-available");
            } else {
                $(".button-add-cart").removeClass("product-unavailable");
                $(".button-add-cart").addClass("product-available");
            }


            // CHANGE URL
            var url = window.location.href;
            var parts = url.split("?");
            var urlWithoutParams = parts[0];
            urlWithoutParams += "?variant=" + variant[1];
            history.pushState(null, null, urlWithoutParams);
        }
        function GotoImages() {
            let variant = currentSelectedComboProperties();
            if (variant !== undefined && variant[6] != null) {
                /*
                let image = $('.product__images').find('[data-media="' + variant[6] + '"]');
                var height_menu = $(".header-menu").outerHeight();
                $('html, body').animate({
                    scrollTop: parseInt(image.offset().top - height_menu)
                }, 300);
                */

                /* SWIPER HASH NAVIGATION*/
                var id_image = variant[6];
                window.location.hash = id_image;
            }
        }

        //mr_test
        function changeColorLegs(elementClicked){
          //if((elementClicked && elementClicked.getAttribute('name').toLowerCase() === 'color') || (elementClicked && elementClicked.getAttribute('name').toLowerCase() === 'colour') || (elementClicked && elementClicked.getAttribute('name').toLowerCase() === 'couleur')){
            var colorChange = getComputedStyle(elementClicked).getPropertyValue('--data-color').trim();
            //console.log("colorchange: "+colorChange);
            const legElementParent = document.querySelector('.attributes__item-color.leg');
            if (legElementParent) {
              const legElementSon = legElementParent.querySelector('input');
              if (legElementSon) {
                if(colorChange){legElementSon.style.setProperty('--data-color', colorChange);}
                //console.log(legsStructure);
                // Obtenemos el ID de la variante seleccionada
                const currentVariantID = currentSelectedComboProperties()[1].toString();
                //console.log("ID Variante Actual:", currentVariantID);
                
                // Recorremos cada tipo de pata en legsStructure
                Object.keys(legsStructure).forEach(legType => {
                  // Buscar el objeto que tenga el id buscado dentro del array correspondiente al legType
                  const equivalence = legsStructure[legType].find(item => item.id === currentVariantID);
                
                  if (equivalence) {
                    //console.log(`Tipo de Pata: ${legType}`);
                    //console.log("Equivalente ID:", equivalence.equivalent_id);
                    //console.log("Handle Equivalente:", equivalence.equivalent_handle);
                
                    // Seleccionar todos los elementos con el atributo data-leg-type igual al legType
                    const elements = document.querySelectorAll(`[data-leg-type="${legType}"]`);
                
                    // Actualizar el atributo onclick de cada elemento
                    elements.forEach(element => {
                      const newOnclickValue = `window.location.href='/products/${equivalence.equivalent_handle}?variant=${equivalence.equivalent_id}';`;
                      element.setAttribute("onclick", newOnclickValue);
                      //console.log(`Actualizado onclick para ${legType} con: ${newOnclickValue}`);
                    });
                  } else {
                    //console.log(`ID ${currentVariantID} no encontrado para el tipo de pata ${legType}`);
                  }
                });
                
              }
            }
          //}
        }
        //mr_test


        // handle variants clicks (swatches)
        $(".variant_option").on("click", function () {
            try{
              checkCombo($(this)[0]);
              refreshPrice();
              GotoImages();
              // mr_test
              changeColorLegs($(this)[0]);
              // mr_test
            }catch(error){
              //console.log(error);
            }
        });

        //
        // VARIATIONS COMBO CHECKER
        //
        // vars
        let sections = [];
        let currentSelected = [];
        let availableCombos = [];

        // set button styles according to availability
        function setButtonStyle(but) {
            if (!but) return null;

            const [level, ...pname] = but.dataset.variation.split("|");

            // filter available combos that fits criteria
            let filt = [];

            for (combo of availableCombos) {
                const cols = combo[0].split(" / ");

                // check if this combo contains this variant
                if (cols[level] == pname) filt.push(combo);
            }

            // never should happen...
            if (filt.length == 0) {
                console.info("Invalid Combo");
                return null;
            }

            // for each section
            for (let s = 0; s < sections.length; s++) {
                if (s == level) continue;
                // for each option
                let dropdowns = false;
                let buttons = sections[s].getElementsByClassName("variant_option");
                if (buttons.length == 0) {
                    buttons = $(sections[s]).find(".variant_option_dropdown>option");
                    dropdowns = true;
                }

                for (el of buttons) {

                    // clear no stock class
                    el.classList.remove("product-unavailable");
                    if (!dropdowns) el.parentElement.classList.remove("butNoStock");

                    // check if in cols of available combos
                    let flag = "butNo";
                    for (combo of filt) {
                        const cols = combo[0].split(" / ");
                        for (let r = 0; r < cols.length; r++) {
                            if (r == level) continue;
                            if (r + "|" + cols[r] == el.dataset.variation) {
                                if (flag.length > 0) el.classList.remove(flag);
                                if (!dropdowns) {
                                    if (flag == "product-unavailable") {
                                        el.parentElement.classList.remove("butNoStock")
                                    } else {
                                        if (flag.length > 0) el.parentElement.classList.remove(flag);
                                    }
                                }

                                flag = "";
                                if (!combo[2]) flag = "product-unavailable";
                                if (dropdowns && flag == "") {
                                    el.innerHTML = el.dataset.variation.split("|")[1];
                                    el.disabled = false;
                                }
                                break;
                            }
                        }
                        if (flag.length) {
                            el.classList.add(flag);
                            if (dropdowns) {
                                if (flag == "product-unavailable") {
                                    el.innerHTML = el.dataset.soldout;
                                    el.disabled = true;
                                }
                            }
                            //mr_test
                            // previous condition:
                            //if (!dropdowns) (flag == "product-unavailable" ? el.parentElement.classList.add("butNoStock") : el.parentElement.classList.add(flag));
                            if (!dropdowns && !el.parentElement.classList.contains('leg')) (flag == "product-unavailable" ? el.parentElement.classList.add("butNoStock") : el.parentElement.classList.add(flag));
                            //mr_test
                        }
                        if (currentSelected[s] == el) {
                            el.classList.add("butSelect");
                            if (!dropdowns) el.parentElement.classList.add("butSelect");
                        } else {
                            el.classList.remove("butSelect");
                            if (!dropdowns) el.parentElement.classList.remove("butSelect");
                        }
                    }
                }
            }
        }


        // init all controls ids and disable unavailable
        function initComboCheck(variants, variation_sections) {
            // get all possible combos from liquid
            availableCombos = [];
            currentSelected = [];
            let vars = JSON.parse($(variants).html());
            for (let i = 0; i < vars.length; i++) {
                let v = vars[i];
                // DON'T CHANGE FIELD ORDER
                availableCombos.push([v["title"], v["id"], v["available"], v["inventory"], v["price"], v["compare_at_price"], v["media"]]);
            };

            let level = 0;
            sections = variation_sections;
            for (const section of sections) {
                // write current level to id
                section.id = level;
                let dropdowns = false;

                let buttons = section.getElementsByClassName("variant_option");
                if (buttons.length == 0) {
                    buttons = $(section).find(".variant_option_dropdown>option");
                    dropdowns = true;
                }

                for (let but of buttons) {
                    but.dataset.variation = level + "|" + but.value.replaceAll(" / ", "/");
                    // check if available
                    but.disabled = true;
                    for (combo of availableCombos) {
                        const cols = combo[0].split(" / ");

                        // check if this combo contains this variant
                        if (cols[level] == but.value.replaceAll(" / ", "/")) {
                            but.disabled = false;
                            break;
                        }
                    }

                    // get current selected button
                    if (dropdowns && $(but).is(":selected")) {
                        currentSelected[level] = but;
                        $(but).addClass("butSelect");
                    } else if (but.checked) {
                        currentSelected[level] = but;
                        //but.checked = true;
                        but.classList.add("butSelect");
                        but.parentElement.classList.add("butSelect");
                    }
                }
                level++;
            }

            // force initial available check for each section (level)
            for (let i = sections.length - 1; i >= 0; i--) {
                setButtonStyle(currentSelected[i]);
            }
        }


        // return current selected buttons to combo path string
        function currentSelectedToComboString() {
            let [level, ...comboPath] = currentSelected[0].dataset.variation.split("|");
            //comboPath[0] = comboPath[0].replaceAll(" / ", " / ");
            for (let l = 1; l < sections.length; l++) {
                comboPath += ' / ' + currentSelected[l].dataset.variation.split("|")[1];
            }

            return comboPath;
        }

        // get variant from combo string
        function comboStringToCombo(pname) {
            // filter available combos that fits criteria
            for (combo of availableCombos) {
                if (combo[0] == pname) {
                    return combo;
                }
            }
        }

        // get current selected combo array item
        function currentSelectedComboProperties() {
            return comboStringToCombo(currentSelectedToComboString());
        }


        // check available options after combo change
        function checkCombo(but) {
            const [level, ...name] = but.dataset.variation.split("|");

            // already pressed button, just exit
            //if (currentSelected[level] === but) return;
            currentSelected[level] = but;

            // recalculate available options
            setButtonStyle(currentSelected[level]);

            // check if we must change current selected buttons because of availability
            let newBut = but;
            for (let l = 0; l < sections.length; l++) {
                // check if we must change the selection of other levels
                if (l != level && $(currentSelected[l]).hasClass("butNo")) {
                    $(sections[l]).find("[data-variation]").each(function () {
                        // check if button is enabled
                        if (!$(this).hasClass("butNo")) {
                            newBut = $(this)[0];
                            return false;
                        }
                    });

                    // activate current selected button
                    if (currentSelected[l] != newBut) {
                        currentSelected[l] = newBut;
                        // recalculate available options
                        setButtonStyle(currentSelected[l]);
                    }
                }
            }
            // recalculate available options, reevaluate clicked button
            setButtonStyle(currentSelected[level]);

            // update button selected class (not dropdowns)
            for (let l = 0; l < sections.length; l++) {
                for (but of sections[l].getElementsByClassName("variant_option")) {
                    if (currentSelected[l] == but) {
                        but.classList.add("butSelect");
                        but.parentElement.classList.add("butSelect");
                    } else {
                        but.classList.remove("butSelect");
                        but.parentElement.classList.remove("butSelect");
                    }
                }
            }
        }

        // auto init combocheck
        $(document).ready(function () {
            if (typeof initComboCheck === 'function' && $("#variants-json").length) initComboCheck($("#variants-json"), $("[name='variant_section']"));
        });
    }
}

Variations.init();
